import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';

export const StreetLine = ({ required, id, model, label, streetLine }) => {
  const updatedLabel = !required ? `${label} (Optional)` : label;

  return (
    <React.Fragment>
      <TextInput
        label={updatedLabel}
        model={model}
        validators={{
          required: required ? `${updatedLabel} is required.` : '',
        }}
        formatter={(value) => {
          return value.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
        }}
        data-testid={`street-line-${streetLine}`}
        maxLength={80}
        isClearable
        name={`${model}-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};

StreetLine.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  streetLine: PropTypes.string,
};

StreetLine.defaultProps = {
  required: false,
  id: 'address-street-line-input',
  label: 'Street Line',
  streetLine: '',
};
